import LazyLoad from "vanilla-lazyload";
import GLightbox from 'glightbox';
import Glide, { Controls, Swipe, Breakpoints, Peek, Gaps } from '@glidejs/glide/dist/glide.modular.esm';
import './form';

document.addEventListener("DOMContentLoaded", () => {

    var lazy = new LazyLoad({
        elements_selector: ".lazy"
    });

    var lightbox = GLightbox({
        selector: 'lightbox'
    });

    const mobileMenuTrigger = document.querySelector('#mobileMenuToggle');
    const mobileMenu = document.querySelector('#mobileMenu');
    bindEvent(mobileMenuTrigger, 'click', toggleMenu);

    function toggleMenu(element)
    {
        element.preventDefault();
        if(mobileMenu.classList.contains('hidden')) {
            mobileMenu.classList.add('block');
            mobileMenu.classList.add('h-auto');
            mobileMenu.classList.remove('hidden');
            mobileMenuTrigger.classList.add('open');
        } else {
            mobileMenu.classList.remove('block');
            mobileMenu.classList.remove('h-auto');
            mobileMenu.classList.add('hidden');
            mobileMenu.classList.add('h-0');
            mobileMenuTrigger.classList.remove('open');
        }
    }

    // ACCORDIONS
    const accordionItems = document.querySelectorAll('[data-accordion-item]');
    const accordionContentPanes = document.querySelectorAll('[data-accordion-content]');
    if (accordionItems.length) {
        accordionItems.forEach(function(accordion) {
            const accordionTitleRow = accordion.firstElementChild;
            bindEvent(accordionTitleRow, 'click', toggleAccordion);
        });
    } 

    function toggleAccordion(e) {
       
        if(e.target.parentElement.classList.contains('accordion-item--active')) {
            e.target.parentElement.classList.remove('accordion-item--active');
            return;
        }
        accordionContentPanes.forEach(function(content) {
            if (content.previousElementSibling === e.target) {
                if(!("accordionAllowMultiple" in content.parentNode.dataset)) {
                    content.classList.remove('accordion-item--active');
                }
                content.parentElement.classList.add('accordion-item--active');
            } else {
                if(!("accordionAllowMultiple" in content.parentNode.dataset)) {
                    content.parentElement.classList.remove('accordion-item--active');
                }
                content.classList.add('accordion-item--active');
            }
        });
    }

    function bindEvent(el, eventName, eventHandler) {
	    if (el.addEventListener){
	        el.addEventListener(eventName, eventHandler, false);
	    } else if (el.attachEvent){
	        el.attachEvent('on'+eventName, eventHandler);
	    }
    }
    
    const glideEl = document.querySelectorAll('.glide');
    if (glideEl.length) {
        var glide = new Glide('.glide', {
            startAt: 0,
            perView: 1,
            peek: {
                before: 25,
                after: 70
            },
            gap: 25,
        });
        glide.mount({ Swipe });
    }  

});